module.exports = __webpack_public_path__ + "c0a9d318af557bfb692bc9ad85eb3190.png";